export interface VatReturnCompletenessCardProps {
    documentCount: number;
    matchedCount: number;
    matchedPercentage: number | null;
    periodText: string;
}

export function VatReturnCompletenessCard({ documentCount, matchedCount, matchedPercentage, periodText }: VatReturnCompletenessCardProps) {
    const percentage = matchedPercentage;

    return (
        <section aria-label="Volledigheid" className="rounded-lg border border-gray-200 bg-white p-5">
            <div className="flex items-center gap-4">
                <div className={percentage === null
                    ? 'flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-gray-100'
                    : 'flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-green-100'}
                >
                    <span className={percentage === null ? 'text-base font-bold text-gray-500' : 'text-base font-bold text-green-800'}>
                        {percentage === null ? '–' : `${percentage}%`}
                    </span>
                </div>
                <div className="flex flex-col gap-1">
                    {percentage === null ? (
                        <p className="text-sm leading-relaxed text-gray-900">Er zijn geen documenten gevonden {periodText}.</p>
                    ) : (
                        <p className="text-sm leading-relaxed text-gray-900">
                            Deze aangifte is gegenereerd op basis van {documentCount} {documentCount === 1 ? 'document' : 'documenten'} {periodText}.{' '}
                            {percentage}% daarvan {documentCount === 1 ? 'is' : 'zijn'} gematched ({matchedCount}).
                        </p>
                    )}
                    <p className="text-xs leading-relaxed text-gray-500">
                        PocketCFO kan fouten maken, review alle documenten voor een definitieve aangifte.
                    </p>
                </div>
            </div>
        </section>
    );
}
